import { AlertCircle } from "lucide-react";

export default function Field({
  id,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  error,
  hint,
  icon: Icon,
  suffix,
  disabled = false,
  autoComplete,
  onBlur,
  inputMode,
  maxLength,
  testId,
  status,
}) {
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={id}
          className="mb-1.5 flex items-center justify-between text-[12px] font-semibold uppercase tracking-[0.14em] text-[hsl(220,30%,28%)]"
        >
          <span>{label}</span>
          {hint && !error && (
            <span className="text-[11px] font-medium normal-case tracking-normal text-[hsl(220,15%,46%)]">
              {hint}
            </span>
          )}
          {status && !error && (
            <span className={`text-[11px] font-medium normal-case tracking-normal ${
              status === 'available' ? 'text-[hsl(152,60%,25%)]' : status === 'taken' ? 'text-[hsl(356,78%,45%)]' : 'text-[hsl(220,15%,46%)]'
            }`}>
              {status === 'available' ? 'Available' : status === 'taken' ? 'Already exists — use a different one' : 'Checking...'}
            </span>
          )}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <Icon
            className={`pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 ${
              error ? "text-[hsl(356,78%,52%)]" : "text-[hsl(220,15%,46%)]"
            }`}
            strokeWidth={1.75}
          />
        )}
        <input
          id={id}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          placeholder={placeholder}
          autoComplete={autoComplete}
          inputMode={inputMode}
          maxLength={maxLength}
          data-testid={testId}
          className={`premium-input ${Icon ? "" : "no-icon"} ${error ? "err" : ""} ${
            disabled ? "opacity-60 cursor-not-allowed" : ""
          }`}
        />
        {suffix && (
          <div className="absolute right-2 top-1/2 -translate-y-1/2">{suffix}</div>
        )}
      </div>
      {error && (
        <div
          data-testid={testId ? `${testId}-error` : undefined}
          className="mt-1.5 flex items-center gap-1.5 text-[12px] font-medium text-[hsl(356,78%,45%)]"
        >
          <AlertCircle className="h-3.5 w-3.5" strokeWidth={2} />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
}
